import fetchCycle from '../fetchCycle'
import captureException from 'utils/captureException'

import {ROOM_SELECTION_PAGE_PATH} from 'routes'

import {fetchRoomsSapi} from 'services/rooms'

import {clearError} from 'modules/common/actions/error'
import {navigateTo} from 'modules/browser/actions'
import {fatalError} from 'modules/common/actions/fatalError'

import {MiddlewareType} from 'middlewares'
import timing from 'utils/timing'

import logSAPIService, {
  SAPIServiceStatus,
  SAPIServiceEndpointNames
} from 'performance/logSAPIService'
import {
  roomsFetch,
  roomsFetchDone,
  roomsFetchPending,
  roomsFetchError,
  roomsFetchFatalError,
  changeDates,
  changeRoomsConfig
} from 'modules/rooms/slice'

const requestsTiming = timing()

const middleware: MiddlewareType = store => next => action => {
  const {dispatch} = store

  next(action)

  switch (action.type) {
    case roomsFetch.type: {
      const {params, isMemberPlus, isEmployee, isAuthenticated} = action.payload
      dispatch(clearError())
      requestsTiming.start('roomsFetch')

      fetchCycle(
        dispatch,
        fetchRoomsSapi({...params, isMemberPlus, isEmployee, isAuthenticated}),
        roomsFetchPending,
        roomsFetchDone,
        roomsFetchError,
        roomsFetchFatalError
      )

      logSAPIService(SAPIServiceEndpointNames.Rooms, SAPIServiceStatus.start, {
        params
      })

      break
    }

    case roomsFetchDone.type: {
      const timings = requestsTiming.stop('roomsFetch')

      logSAPIService(SAPIServiceEndpointNames.Rooms, SAPIServiceStatus.done, {
        searchId: action.params,
        timings
      })

      break
    }

    case roomsFetchError.type: {
      const timings = requestsTiming.stop('roomsFetch')

      logSAPIService(
        SAPIServiceEndpointNames.Rooms,
        SAPIServiceStatus.error,
        {params: action.params, timings},
        'error'
      )
      break
    }

    case roomsFetchFatalError.type: {
      const timings = requestsTiming.stop('roomsFetch')

      logSAPIService(
        SAPIServiceEndpointNames.Rooms,
        SAPIServiceStatus.fatalError,
        {response: action?.payload, timings},
        'error'
      )

      captureException(action?.payload)
      dispatch(fatalError(action?.payload))
      break
    }

    case changeDates.type: {
      const {checkIn, checkOut} = action.payload
      dispatch(
        navigateTo(
          ROOM_SELECTION_PAGE_PATH,
          {
            checkIn,
            checkOut,
            price: undefined,
            baseRate: undefined,
            localTax: undefined,
            tax: undefined,
            originalBaseRate: undefined,
            originalTax: undefined,
            originalLocalTax: undefined,
            originalCurrency: undefined
          },
          false,
          true
        )
      )
      break
    }

    case changeRoomsConfig.type:
      dispatch(
        navigateTo(
          ROOM_SELECTION_PAGE_PATH,
          {
            rooms: action.payload,
            price: undefined,
            baseRate: undefined,
            localTax: undefined,
            tax: undefined,
            originalBaseRate: undefined,
            originalTax: undefined,
            originalLocalTax: undefined,
            originalCurrency: undefined
          },
          false,
          true
        )
      )
      break

    default:
      break
  }
}

export default middleware
